@if (showField$ | async) {
  <mat-form-field>
    <textarea matInput
      [attr.rows]="field.attrs.rows || 3"
      [attr.type]="field.type"
      [attr.name]="field.name"
      readonly="readonly"
      [placeholder]="field.placeholder | translate"
    [formControl]="$any(field.control)"></textarea>
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
